module.exports = __webpack_public_path__ + "media/2.7de3a055.mp3";